import { Button } from './ui/button';

/**
 * Estado vacío reutilizable: icono en círculo, título, descripción y acción opcional.
 * Convierte un hueco en blanco en algo amable y, si hay acción, accionable de un clic.
 *
 * Uso:
 *   <EmptyState icon={Users} title="Aún no hay pacientes"
 *     description="Da de alta al primero para empezar."
 *     actionLabel="Nuevo paciente" onAction={openNewPatient} />
 */
export const EmptyState = ({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className = '',
}) => (
  <div className={`flex flex-col items-center justify-center text-center py-12 px-4 ${className}`}>
    {Icon && (
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10">
        <Icon className="h-8 w-8 text-primary" aria-hidden="true" />
      </div>
    )}
    <h3 className="text-base font-semibold text-foreground">{title}</h3>
    {description && (
      <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
    )}
    {actionLabel && onAction && (
      <Button onClick={onAction} className="mt-5">
        {actionLabel}
      </Button>
    )}
  </div>
);
